import { useRedirectContext } from '@lemonade-hq/uniclient-app';
import type { ClientUrlParams, UniclientStepPresentation } from '@lemonade-hq/uniclient-chat';
import React from 'react';
import { Wizard } from '../elements/Wizard';
import { WizardChatEnginePersistenceProvider } from '../persistence/WizardChatEnginePersistenceProvider';
import type { WizardChatEnginePersistenceProps } from '../persistence/WizardChatEnginePersistenceProvider';
import { AutoTriggerActionProvider } from '../providers/AutoTriggerActionProvider';
import { UniclientBrowserNavigationProvider } from '../providers/UniclientBrowserNavigationProvider';
export interface UniclientWizardProps {
  readonly chatEnginePersistence: WizardChatEnginePersistenceProps<UniclientStepPresentation>;
  readonly clientParams: ClientUrlParams | null;
}

export const UniclientWizard = ({ chatEnginePersistence, clientParams }: UniclientWizardProps): React.ReactElement => {
  const { redirectFn } = useRedirectContext();
  return (
    <UniclientBrowserNavigationProvider>
      <AutoTriggerActionProvider>
        <WizardChatEnginePersistenceProvider
          accessTokenOverride={chatEnginePersistence.accessTokenOverride}
          emailCode={chatEnginePersistence.emailCode}
          errorMap={chatEnginePersistence.errorMap}
          forceRestart={chatEnginePersistence.forceRestart}
          initData={chatEnginePersistence.initData}
          initialStepName={clientParams?.initialStepName}
          redirectFn={redirectFn}
          resourceType={chatEnginePersistence.resourceType}
          scriptName={chatEnginePersistence.scriptName}
          serverBaseUrl={chatEnginePersistence.serverBaseUrl}
          serverTimeoutOverride={chatEnginePersistence.serverTimeoutOverride}
          sessionId={chatEnginePersistence.sessionId}
          theme={chatEnginePersistence.theme}
        >
          <Wizard scriptName={chatEnginePersistence.scriptName} />
        </WizardChatEnginePersistenceProvider>
      </AutoTriggerActionProvider>
    </UniclientBrowserNavigationProvider>
  );
};
